import React, { useState, useEffect, Suspense } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import InfiniteScroll from "react-infinite-scroller";
import { useParams } from 'react-router-dom'
import LoadingBar from 'react-top-loading-bar'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import { useForm } from 'react-hook-form'
import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Spinner from '../Global/Spinner';
import VideoBox from '../Global/VideoBox';
import MusicBox from '../Global/MusicBox';
import ImageBox from '../Global/ImageBox';
import ChannelBox from '../Global/ChannelBox'
import SingleGroup from '../Global/SingleGroup';
import SingleWeblink from '../Global/SingleWeblink';
import EmptyContent from '../Global/EmptyContent';

import './Search.css'
import styles from '../../App.module.css'
import classes from './Search.module.css'

import noThumb from "../../images/no-thumb.jpg";

function Search() {
    const { key } = useParams();
    // const {register, handleSubmit} = useForm();
    // const [searchKey, setSearchKey] = useState(key);
    // const [inputValue, setInputValue] = useState(key);
    // const [searchType, setSearchType] = useState('videos');
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [tabIndex, setTabIndex] = useState(0);
    const [progress, setProgress] = useState(0);
    const [type, setType] = useState('videos');

    useEffect(() => {
        document.getElementsByTagName('aside')[0].classList.remove('active');
        document.getElementsByClassName('main-content')[0].classList.add('full-width');
    }, [])

    useEffect(() => {
        setLoading(false);
        if(tabIndex === 0) {
          setType('videos');
        }else if(tabIndex === 1) {
            setType('music');
        }else if(tabIndex === 2) {
          setType('images');
        }else if(tabIndex === 3) {
          setType('channels');
        }else if(tabIndex === 4) {
          setType('groups');
        }else if(tabIndex === 5) {
          setType('weblinks');
        }
      }, [tabIndex]);

    // const onSubmit = data => {
    //     setSearchKey(data.key);
    // }

    useEffect(() => {
        fetchData();
    }, [key, type]);

    const fetchData = () => {
        setProgress(20);
        axios.post(`${process.env.REACT_APP_API_URL}/api/search.php`, {
            key: key,
            type: type,
            page: 1,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if(res.data.status !== 'No items found') {
                setSearchResults(res.data);
                res.data.length < 10 ? sethasMore(false) : sethasMore(true);
            }else {
                setSearchResults([]);
                sethasMore(false);
            }
            
            setLoading(true);
            setProgress(100);
        })
    }

    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/search.php`, {
            key: key,
            type: type,
            page: page,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if(res.data.status !== 'No items found') {
                loading && hasMore && setSearchResults([...searchResults, ...res.data]);
                setpage(page + 1);

                res.data.length < 10 ? sethasMore(false) : sethasMore(true);
            }
        })
    };

    // const handleChange = (e) => {
    //     setInputValue(e.target.value);
    // }

  return (
    <>
    <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
    />
    <Header />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <div className="search-component p-4">
                {/* <div className="box">
                    <div className={classes.box_container}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <input {...register('key')} value={inputValue} onChange={handleChange} type="text" id={classes.search} placeholder="Search..." />
                            <button className={classes.search_button}><i className="fa fa-search"></i></button>
                        </form>
                    </div>
                </div> */}
                {/* <div className="sec-tabs mt-3 mb-4">
                    <ul className="d-inline">
                        <li><Link to={false} title='Disabled' className="active">Videos</Link></li>
                        <li><Link to={false} title='Disabled'>Music</Link></li>
                        <li><Link to={false} title='Disabled'>Images</Link></li>
                        <li><Link to={false} title='Disabled'>Channels</Link></li>
                        <li><Link to={false} title='Disabled'>Groups</Link></li>
                        <li><Link to={false} title='Disabled'>WebLinks</Link></li>
                    </ul>
                </div> */}
                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index) }>
                    <TabList>
                        <Tab>Videos</Tab>
                        <Tab>Music</Tab>
                        <Tab>Images</Tab>
                        <Tab>Channels</Tab>
                        <Tab>Groups</Tab>
                        <Tab>WebLinks</Tab>
                    </TabList>
                    <div className={`${classes.search_key} mt-4`}>
                        <h4>Results for #{key}</h4>
                    </div>
                    <TabPanel>
                        {
                            loading && type === 'videos' && searchResults && searchResults.map ? <InfiniteScroll
                                pageStart={0}
                                loadMore={loadMore}
                                hasMore={hasMore}
                                loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                className="row m-0"
                            >
                                {
                                    searchResults && searchResults.map && searchResults.map((item, index) => {
                                        return (
                                            <div className="col-lg-3 col-sm-6" key={index}>
                                                {
                                                    VideoBox(item)
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </InfiniteScroll>
                            : <EmptyContent />
                        }
                    </TabPanel>
                    <TabPanel>
                        {
                            loading && type === 'musics' && searchResults && searchResults.map ? <InfiniteScroll
                                pageStart={0}
                                loadMore={loadMore}
                                hasMore={hasMore}
                                loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                className="row m-0"
                            >
                                {
                                    searchResults && searchResults.map && searchResults.map((item, index) => {
                                        return (
                                            <div className="" key={index}>
                                                {
                                                    MusicBox(item)
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </InfiniteScroll>
                            : <EmptyContent />
                        }
                    </TabPanel>
                    <TabPanel>
                        <div className={styles.gallery}>
                            {
                                loading && type === 'images' && searchResults && searchResults.map ? <InfiniteScroll
                                    pageStart={0}
                                    loadMore={loadMore}
                                    hasMore={hasMore}
                                    loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                    className="row m-0"
                                >
                                    {
                                        searchResults && searchResults.map && searchResults.map((item, index) => {
                                            return (
                                                <div className={`${styles.item} col-lg-3 col-md-4 col-6 col-sm`} key={index}>
                                                    {
                                                        ImageBox(item)
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </InfiniteScroll>
                                : <EmptyContent />
                            }
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={classes.channels}></div>
                        {
                            loading && type === 'channels' && searchResults && searchResults.map ? <InfiniteScroll
                                pageStart={0}
                                loadMore={loadMore}
                                hasMore={hasMore}
                                loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                className="row m-0"
                            >
                                {
                                    searchResults && searchResults.map && searchResults.map((item, index) => {
                                        return (
                                            <div className={`${classes.channel} p-0`} key={index}>
                                                {
                                                    ChannelBox(item)
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </InfiniteScroll>
                            : <EmptyContent />
                        }
                    </TabPanel>
                    <TabPanel>
                        {
                            loading && type === 'groups' && searchResults && searchResults.map ? <InfiniteScroll
                                pageStart={0}
                                loadMore={loadMore}
                                hasMore={hasMore}
                                loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                className="row m-0"
                            >
                                {
                                    searchResults && searchResults.map && searchResults.map((item, index) => {
                                        return (
                                            <div className="col-md-4" key={index}>
                                                {
                                                    SingleGroup(item)
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </InfiniteScroll>
                            : <EmptyContent />
                        }
                    </TabPanel>
                    <TabPanel>
                        {
                            loading && type === 'weblinks' && searchResults && searchResults.map ? <InfiniteScroll
                                pageStart={0}
                                loadMore={loadMore}
                                hasMore={hasMore}
                                loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                className="row m-0"
                            >
                                {
                                    searchResults && searchResults.map && searchResults.map((item, index) => {
                                        return (
                                            <div className="col-md-4" key={index}>
                                                {
                                                    SingleWeblink(item)
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </InfiniteScroll>
                            : <EmptyContent />
                        }
                    </TabPanel>
                </Tabs>
            </div>
          </div>
        </Suspense>
      </div>
      </>
  )
}

export default Search